"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textMediaFields = exports.textMediaDefaults = exports.textMediaShape = void 0;
const zod_1 = require("zod");
const _appearance_1 = require("./_appearance");
/**
 * Shared "text + image" definition (SP5) used by BOTH `rich-text` and the
 * legacy `image-with-text` type so they behave identically — the user only
 * needs one section. Covers: heading + body, text size, an optional image with
 * layout (none/left/right/top/overlay), aspect ratio, and fit (cover/contain/
 * fill/tile), a CTA, plus the shared appearance + button styling.
 */
exports.textMediaShape = {
    title: zod_1.z.string().max(160).default(''),
    body: zod_1.z.string().max(5000).default(''),
    textSize: zod_1.z.enum(['sm', 'md', 'lg', 'xl']).default('md'),
    imageUrl: zod_1.z.string().default(''),
    imageLayout: zod_1.z.enum(['none', 'left', 'right', 'top', 'overlay']).default('left'),
    imageRatio: zod_1.z.enum(['auto', 'square', 'landscape', 'wide', 'portrait']).default('landscape'),
    imageFit: zod_1.z.enum(['cover', 'contain', 'fill', 'tile']).default('cover'),
    overlayOpacity: zod_1.z.number().min(0).max(100).default(40),
    ctaLabel: zod_1.z.string().max(60).default(''),
    ctaHref: zod_1.z.string().default(''),
    ..._appearance_1.appearanceShape,
    ..._appearance_1.buttonShape,
};
const textMediaDefaults = () => ({
    title: '', body: '', textSize: 'md',
    imageUrl: '', imageLayout: 'left', imageRatio: 'landscape', imageFit: 'cover', overlayOpacity: 40,
    ctaLabel: '', ctaHref: '', buttonStyle: 'solid',
    ...(0, _appearance_1.appearanceDefaults)(),
});
exports.textMediaDefaults = textMediaDefaults;
exports.textMediaFields = [
    { name: 'title', label: 'Heading', control: 'text', group: 'Content' },
    { name: 'body', label: 'Body', control: 'textarea', group: 'Content' },
    { name: 'textSize', label: 'Text size', control: 'select', group: 'Content', options: [
            { label: 'Small', value: 'sm' }, { label: 'Medium', value: 'md' }, { label: 'Large', value: 'lg' }, { label: 'Extra large', value: 'xl' },
        ] },
    { name: 'ctaLabel', label: 'Button label', control: 'text', group: 'Content' },
    { name: 'ctaHref', label: 'Button URL', control: 'url', group: 'Content' },
    // Image group
    { name: 'imageUrl', label: 'Image', control: 'image', group: 'Image' },
    { name: 'imageLayout', label: 'Placement', control: 'select', group: 'Image', options: [
            { label: 'No image', value: 'none' }, { label: 'Left of text', value: 'left' }, { label: 'Right of text', value: 'right' },
            { label: 'Above text', value: 'top' }, { label: 'Text over image', value: 'overlay' },
        ] },
    { name: 'imageRatio', label: 'Aspect ratio', control: 'select', group: 'Image', options: [
            { label: 'Original', value: 'auto' }, { label: 'Square (1:1)', value: 'square' },
            { label: 'Landscape (4:3)', value: 'landscape' }, { label: 'Wide (16:9)', value: 'wide' }, { label: 'Portrait (3:4)', value: 'portrait' },
        ] },
    { name: 'imageFit', label: 'Fit', control: 'select', group: 'Image', options: [
            { label: 'Cover (fill & crop)', value: 'cover' }, { label: 'Contain (show all)', value: 'contain' },
            { label: 'Stretch', value: 'fill' }, { label: 'Tile', value: 'tile' },
        ] },
    { name: 'overlayOpacity', label: 'Overlay darkness (%)', control: 'number', min: 0, max: 100, group: 'Image', showWhen: { field: 'imageLayout', equals: 'overlay' } },
    ..._appearance_1.appearanceFields,
    ..._appearance_1.buttonFields,
];
//# sourceMappingURL=_textmedia.js.map